import '../../Style/ViewDoc.css'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { PaperComponent } from '../Helpers/Drag'

export const CommentEditModal = ({
  showModal,
  setShowModal,
  addComment,
  currentComment,
  prompt
}) => {
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (currentComment) {
      setMessage(currentComment.message)
    }
  }, [currentComment])

  function handleMessageChange (e) {
    let value = e.target.value
    setMessage(value)
  }

  return (
    <Dialog
      open={showModal}
      onClose={() => setShowModal(false)}
      PaperProps={{
        component: 'form',
        onSubmit: e => {
          e.preventDefault()
          let comment = { ...currentComment }
          comment.message = message
          comment.messageType = 'Vote'
          const d = new Date()
          comment.editTime = d
          comment.dateString = d.toDateString()
          addComment(comment)
        }
      }}
      fullWidth
      PaperComponent={PaperComponent}
      aria-labelledby='draggable-dialog-title'
    >
      <DialogTitle style={{ cursor: 'move' }}>
        Add a Comment to your Response for: <br />
        <b>{prompt.substring(0, 100) + (prompt.length > 100 ? '...' : '')}</b>
      </DialogTitle>
      <DialogContent>
        <TextField
          id='outlined-multiline-static'
          label='Comment'
          multiline
          rows={4}
          fullWidth
          variant='filled'
          value={message}
          onChange={handleMessageChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShowModal(false)} variant='outlined'>
          Cancel
        </Button>
        <Button
          type='submit'
          variant='contained'
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CommentEditModal
